
import {defineComponent, PropType} from "vue";
import {
  CustomerProductWithImageOverviewRestDtoModel
} from "@/models/api/pharma-cpc-product-mgmt/CustomerProductWithImageOverviewRestDtoModel";
import {UIStateDto} from "@/dtos/UIStateDto";
import BaseDeleteButton from "@/components/UI/Bootstrap/BaseDeleteButton.vue";
import BaseEditButton from "@/components/UI/Bootstrap/BaseEditButton.vue";

export default defineComponent({
  name: "ProductsOverviewItem",
  components: {BaseEditButton, BaseDeleteButton},
  emits: ["delete"],
  props: {
    product: {
      type: Object as PropType<CustomerProductWithImageOverviewRestDtoModel>,
      required: true
    },
    pageUI: {
      type: Object as PropType<UIStateDto>,
      required: true
    }
  },
  methods: {
    deleteProduct(productCode: string) {
      this.$emit('delete', productCode);
    },
  }
});
